<template>
  <!-- .profile -->
  <div class="company-profile-page">
    <div class="container edit-user-template">
      <h1 class="page-header color-1-100">
        <template v-if="canEditDetails">
          Edit my company subscription
        </template>
        <template v-else>
          My company subscription
        </template>
      </h1>
      <div class="flex-block">
        <div class="content-right-section anchors">
          <div class="sticky-anchors background-1-40-before" tabindex="-1">
            <div class="anchor-item anchor-item-custom color-1-20 details"
                 :class="[{ 'active  color-1-100': activeSection === 'companyDetails' }]">
              <a href="#" @click.prevent="goToPageSection('companyDetails')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 18" style="enable-background:new 0 0 20 18;" xml:space="preserve">
                    <path id="XMLID_1_" class="st0" d="M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12
                      c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8
                      S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1
                      C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"/>
                  </svg>
                </span>
                <template v-if="canEditDetails === false">Company details</template>
                <template v-else>Edit company details</template>
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 email-endings"
                 v-if="getUserRole === 'ta' || getUserRole === 'gm'"
                 :class="[{ 'active  color-1-100': activeSection === 'companyEmails' }]">
              <a href="#" @click.prevent="goToPageSection('companyEmails')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 13" style="enable-background:new 0 0 20 13;" xml:space="preserve">
                    <g id="XMLID_8_">
                      <path id="XMLID_10_" class="st0" d="M10,5.823l8.965-5.564C18.678,0.1,18.352,0,18,0H2C1.648,0,1.322,0.1,1.035,0.259L10,5.823z"/>
                      <path id="XMLID_9_" class="st0" d="M10.527,7.85C10.366,7.95,10.183,8,10,8C9.817,8,9.634,7.95,9.473,7.85l-9.47-5.877
                        C0.003,1.982,0,1.991,0,2v9c0,1.102,0.897,2,2,2h16c1.103,0,2-0.898,2-2V2c0-0.009-0.003-0.018-0.003-0.027L10.527,7.85z"/>
                    </g>
                  </svg>
                </span>
                <template v-if="canEditEmails === false">Approved domains for emails</template>
                <template v-else>Edit approved domains for emails</template>
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 owner"
                 :class="[{ 'active  color-1-100': activeSection === 'companyOwner' }]">
              <a href="#" @click.prevent="goToPageSection('companyOwner')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 10 20" style="enable-background:new 0 0 10 20;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <circle id="XMLID_2_" class="st0" cx="5" cy="3" r="3"/>
                      <path id="XMLID_3_" class="st0" d="M5,6c-2.757,0-5,2.243-5,5v3c0,0.552,0.448,1,1,1h1v4c0,0.552,0.448,1,1,1h4
                        c0.552,0,1-0.448,1-1v-4h1c0.552,0,1-0.448,1-1v-3C10,8.243,7.757,6,5,6z"/>
                    </g>
                  </svg>
                </span>
                <template v-if="canEditOwner === false">Product owner</template>
                <template v-else>Edit product owner</template>
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 tasks"
                 v-if="getUserRole === 'ca'"
                 :class="[{ 'active  color-1-100': activeSection === 'tasksSettings' }]">
              <a href="#" @click.prevent="goToPageSection('companyOwner')">
                <span class="anchor-item-icon color-1-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
                    <path class="st0" d="M.5-10a.442.442,0,0,1-.5-.5v-1A.442.442,0,0,1,.5-12h13a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5Zm15,3a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5H2.5A.442.442,0,0,1,2-5.5v-1A.442.442,0,0,1,2.5-7Zm-2,5a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5H.5A.442.442,0,0,1,0-.5v-1A.442.442,0,0,1,.5-2Z" transform="translate(0 12)"/>
                  </svg>
                </span>
                <template v-if="canEditDetails === false">Tasks settings</template>
                <template v-else>Edit tasks settings</template>
              </a>
            </div>
          </div>
        </div>
        <div class="content-left-section">
          <template v-if="this.tabActive === 'profile'">
            <div class="content-section profile-section no-margin-top"
                 :class="[{ 'content-section__bordered border-1-20': activeSection === 'companyDetails' || canEditDetails }]"
                 tabindex="-1"
                 ref="companyDetails">
              <article class="personal-info">
                <h3 class="content-section-title color-1-100 background-1-100-before">
                  <template v-if="canEditDetails === false">Company subscription details</template>
                  <template v-else>Edit company subscription details</template>
                </h3>
                <a href="#" v-on:click.prevent="openEditDetails()" class="edit-details edit-details-custom border-1-40 color-2-100"
                   v-if="canEditDetails === false && (getUserRole === 'ca' || getUserRole === 'ta')">
                  <span class="edit-icon color-1-100">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                      <g id="XMLID_1_">
                        <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                          c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                        <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                          L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                          l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                      </g>
                    </svg>
                  </span>
                  Edit
                </a>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="new-company-name" class="form-label color-2-63">Company name</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :class="[{ 'has-error': errors.has('Company name'), 'is-locked': !canEditDetails }]"
                           :disabled="canEditDetails === false"
                           data-lpignore="true"
                           v-on:keyup="fieldChange"
                           v-model="company.details.name"
                           id="new-company-name"
                           name="Company name">
                    <span class="form-field-error" v-if="this.errors.has('Company name')">{{ this.errors.first('Company name') }}</span>
                  </div>
                  <div class="form-element" v-if="getUserRole === 'ca' || getUserRole === 'ta'">
                    <label for="new-company-parent" class="form-label color-2-63">Parent company</label>
                    <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked is-blocked"
                              :class="[{ 'has-error': errors.has('Company name'), 'is-locked': !canEditDetails }]"
                              :disabled="true"
                              :searchable = true
                              v-model="company.details.parent"
                              :options="preparedCompanies"
                              data-vv-name="Parent company"
                              data-lpignore="true"
                              name="Company status"
                              id="new-company-parent" />
                    <span class="form-field-error" v-if="this.errors.has('Parent company')">{{ this.errors.first('Parent company') }}</span>
                  </div>
                </div>
                <div class="form-group form-group-half" v-if="getUserRole !== 'ca' && getUserRole !== 'ta'">
                  <div class="form-element">
                    <label for="new-company-parent" class="form-label color-2-63">Parent company</label>
                    <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                              :class="[{ 'has-error': errors.has('Company name'), 'is-locked': !canEditDetails }]"
                              :disabled="canEditDetails === false"
                              :searchable = true
                              v-model="company.details.parent"
                              :options="preparedCompanies"
                              data-vv-name="Parent company"
                              data-lpignore="true"
                              name="Company status"
                              id="new-company-parent" />
                    <span class="form-field-error" v-if="this.errors.has('Parent company')">{{ this.errors.first('Parent company') }}</span>
                  </div>
                </div>
                <div class="form-group form-group-half" v-if="getUserRole === 'ca' || getUserRole === 'ta'">
                  <div class="form-element form-element-date" id="date-selector">
                    <label for="new-company-subscription-end" class="form-label color-2-63">Subscription ends on:</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked"
                           disabled="disabled"
                           data-lpignore="true"
                           :class="[{ 'has-error': errors.has('Subscription ends'), 'is-locked': !canEditDetails }]"
                           id="new-company-subscription-end"
                           name="Subscription ends"
                           @focus="datepicker.shown = true"
                           v-model="company.details.subscriptionEnd"
                    />
                    <div class="datepicker" v-show="canEditDetails && datepicker.shown">
                      <div class="datepicker-calendar-half">
                        <datepicker
                          :inline="true"
                          v-model="datepicker.subscription"
                          @selected="dateSelected($event)"
                          :open-date="datepicker.subscription"
                          :format="'dd/MM/yyyy'"
                        />
                      </div>
                    </div>
                    <span class="form-field-error" v-if="this.errors.has('Subscription ends')">{{ this.errors.first('Subscription ends') }}</span>
                  </div>
                  <div class="form-element">
                    <label for="new-company-limit" class="form-label color-2-63">Employee limit</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked"
                           disabled="disabled"
                           data-lpignore="true"
                           :class="[{ 'is-locked': !canEditDetails }]"
                           id="new-company-limit"
                           name="Employee limit"
                           v-model="company.details.employeeLimit"/>
                    <span class="form-field-error" v-if="this.errors.has('Employee limit')">{{ this.errors.first('Employee limit') }}</span>
                  </div>
                </div>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="new-company-language" class="form-label color-2-63">Default language</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked"
                           disabled="disabled"
                           :class="[{ 'is-locked': !canEditDetails }]"
                           data-lpignore="true"
                           id="new-company-language"
                           name="Default language"
                           v-model="company.details.language"/>
                  </div>
                </div>
                <div class="form-group form-group-half" v-if="getUserRole === 'ca' || getUserRole === 'ta'">
                  <div class="form-element">
                    <label for="new-company-url" class="form-label color-2-63">Company url</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :disabled="canEditDetails === false"
                           data-lpignore="true"
                           :class="[{ 'is-locked': !canEditDetails }]"
                           id="new-company-url"
                           name="Company url"
                           v-model="company.details.url"/>
                  </div>
                </div>
              </article>
              <div class="clearfix"></div>
              <div class="update-data update-data__details" v-if="canEditDetails && (getUserRole === 'ca' || getUserRole === 'ta')">
                <a href="#" v-on:click.prevent="closeEditDetails()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</a>
                <a href="#" v-on:click.prevent="updateCompanyDetails()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</a>
              </div>
            </div>
            <div class="content-section profile-section"
                 :class="[{ 'content-section__bordered border-1-20': activeSection === 'companyEmails' || canEditEmails }]"
                 v-if="getUserRole === 'ta' || getUserRole === 'gm'"
                 tabindex="-1"
                 ref="companyEmails">
              <article class="personal-info">
                <h3 class="content-section-title color-1-100 background-1-100-before">
                  <template v-if="canEditEmails === false">Approved domains for emails</template>
                  <template v-else>Edit approved domains for emails</template>
                </h3>
                <a href="#" v-on:click.prevent="openEditEmails()" class="edit-details edit-details-custom border-1-40 color-2-1000"
                   v-if="canEditEmails === false && (getUserRole === 'ca' || getUserRole === 'ta')">
                  <span class="edit-icon color-1-100">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                      <g id="XMLID_1_">
                        <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                          c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                        <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                          L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                          l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                      </g>
                    </svg>
                  </span>
                  Edit
                </a>
                <div class="form-group form-group-half"
                     v-for="(row, index) in company.approvedEmails"
                     :class="[{ 'form-group-right-item': (index > 0 && (index + 1) % 2 === 0) && canEditEmails === true, 'form-group__email-ending-input' : canEditEmails === true }]">
                  <div class="form-element">
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :disabled="canEditEmails === false"
                           v-show="(row.email !== '' && canEditEmails === false) || canEditEmails === true"
                           v-model="row.email"
                           data-lpignore="true"/>
                  </div>
                  <div class="form-group form-group-half form-group__email-ending-button form-group__email-ending-remove"
                       v-if="canEditEmails === true && (getUserRole === 'ca' || getUserRole === 'ta')">
                    <a href="#" tabindex="0" class="add-email-ending" @click.prevent="removeElement(index)"></a>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div class="form-group form-group__email-add-button"
                     v-if="canEditEmails === true && (getUserRole === 'ca' || getUserRole === 'ta')">
                  <a href="#" tabindex="0" class="add-email-ending" @click.prevent="addEmailRow">Add new</a>
                </div>
              </article>
              <div class="clearfix"></div>
              <div class="update-data update-data__details" v-if="canEditEmails && (getUserRole === 'ca' || getUserRole === 'ta')">
                <a href="#" v-on:click.prevent="closeEditEmails()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</a>
                <a href="#" v-on:click.prevent="updateCompanyEmails()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</a>
              </div>
            </div>
            <div class="content-section profile-section"
                 :class="[{ 'content-section__bordered border-1-20': activeSection === 'companyOwner' || canEditOwner }]"
                 tabindex="-1"
                 ref="companyOwner">
              <article class="personal-info">
                <h3 class="content-section-title color-1-100 background-1-100-before">
                  <template v-if="canEditOwner === false">Profile information</template>
                  <template v-else>Edit profile information</template>
                </h3>
                <a href="#" v-on:click.prevent="openEditOwner()" class="edit-details edit-details-custom border-1-40 color-2-100"
                   v-if="canEditOwner === false && (getUserRole === 'ca' || getUserRole === 'ta')">
                  <span class="edit-icon color-1-100">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                      <g id="XMLID_1_">
                        <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                          c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                        <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                          L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                          l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                      </g>
                    </svg>
                  </span>
                  Edit
                </a>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="owner-first-name" class="form-label color-2-63">Account owner first name</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :class="[{ 'has-error': errors.has('First name'), 'is-locked': !canEditOwner }]"
                           :disabled="canEditOwner === false"
                           v-model="company.ownerData.firstName"
                           data-lpignore="true"
                           id="owner-first-name"
                           name="First name">
                    <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                  </div>
                  <div class="form-element">
                    <label for="owner-phone" class="form-label color-2-63">Phone number</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :class="[{ 'has-error': errors.has('Phone number'), 'is-locked': !canEditOwner }]"
                           :disabled="canEditOwner === false"
                           v-model="company.ownerData.phoneNumber"
                           data-lpignore="true"
                           id="owner-phone"
                           name="Phone number">
                    <span class="form-field-error" v-if="this.errors.has('Phone number')">{{ this.errors.first('Phone number') }}</span>
                  </div>
                </div>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="owner-first-name" class="form-label color-2-63">Account owner last name</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :class="[{ 'has-error': errors.has('Last name'), 'is-locked': !canEditOwner }]"
                           :disabled="canEditOwner === false"
                           v-model="company.ownerData.lastName"
                           data-lpignore="true"
                           id="owner-last-name"
                           name="Last name">
                    <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                  </div>
                  <div class="form-element">
                    <label for="new-user-email" class="form-label color-2-63">Email</label>
                    <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :class="[{ 'has-error': errors.has('Email'), 'is-locked': !canEditOwner }]"
                           :disabled="canEditOwner === false"
                           data-lpignore="true"
                           id="new-user-email"
                           v-validate="'email'"
                           name="Email"
                           v-model="company.ownerData.email"/>
                    <span class="form-field-error" v-if="this.errors.has('Email')">{{ this.errors.first('Email') }}</span>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div class="update-data update-data__details" v-if="canEditOwner && (getUserRole === 'ca' || getUserRole === 'ta')">
                  <a href="#" v-on:click.prevent="closeEditOwner()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</a>
                  <a href="#" v-on:click.prevent="updateCompanyOwner()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</a>
                </div>
              </article>
            </div>
            <div class="content-section profile-section"
                 :class="[{ 'content-section__bordered border-1-20': activeSection === 'tasksSettings' || canEditTasksSettings }]"
                 v-if="getUserRole === 'ca'"
                 tabindex="-1"
                 ref="tasksSettings">
              <article class="personal-info">
                <h3 class="content-section-title color-1-100 background-1-100-before">
                  <template v-if="canEditTasksSettings === false">Task settings</template>
                  <template v-else>Edit tasks settings</template>
                </h3>
                <button v-on:click.prevent="openTasksSettings()" class="edit-details border-1-40 color-2-100"
                        v-if="canEditTasksSettings === false">Edit
                </button>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="company-contraption" class="form-label color-2-63">Company contraption</label>
                    <input type="text"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           :disabled="canEditTasksSettings === false"
                           data-lpignore="true"
                           :class="[{ 'has-error': errors.has('Company contraption'), 'is-locked': !canEditTasksSettings }]"
                           id="company-contraption"
                           name="Company contraption"
                           v-model="company.tasksSettings.contraption"/>
                  </div>
                </div>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="company-default-assignee" class="form-label color-2-63">Default assignee</label>
                    <v-select
                      class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                      :class="[{ 'has-error': errors.has('Default assignee'), 'is-locked': !canEditTasksSettings }]"
                      :disabled="canEditTasksSettings === false"
                      :searchable=true
                      v-model="company.tasksSettings.defaultAssignee"
                      :options="defaultAssigneeForSelect"
                      data-vv-name="Default assignee"
                      data-lpignore="true"
                      name="Default assignee"
                      id="company-default-assignee"/>
                    <span class="form-field-error" v-if="this.errors.has('Default assignee')">{{ this.errors.first('Default assignee') }}</span>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div class="update-data update-data__details" v-if="canEditTasksSettings">
                  <button v-on:click.prevent="closeEditTasksSettings()"
                          class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes
                  </button>
                  <button v-on:click.prevent="updateCompanyTasksSettings()"
                          class="save-edit background-1-100 color-2-100 save-edit-details">Save changes
                  </button>
                </div>
              </article>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <!-- END:.profile -->
</template>

<script>
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'
  import AppSelect from '@/components/admin/common/Select'

  export default {
    name: 'company-subscription',
    data () {
      return {
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        messageDisplay: false,
        canEditDetails: false,
        canEditEmails: false,
        canEditOwner: false,
        canEditTasksSettings: false,
        confOpened: null,
        company: {
          details: {
            enabled: {
              label: '',
              value: ''
            },
            url: '',
            parent: null,
            language: 'English'
          },
          approvedEmails: [
            {
              email: ''
            }
          ],
          ownerData: {
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: ''
          },
          tasksSettings: {
            contraption: '',
            defaultAssignee: false,
            accountManager: false
          }
        },
        initialData: {
          details: {
            id: '',
            name: '',
            parent: '',
            subscriptionEnd: null,
            employeeLimit: 0,
            enabled: {
              label: '',
              value: ''
            },
            url: '',
            language: 'English'
          },
          approvedEmails: [
            {
              email: ''
            }
          ],
          ownerData: {
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: ''
          },
          tasksSettings: {
            contraption: '',
            defaultAssignee: false,
            accountManager: false
          }
        },
        confirmation: {
          action: '',
          isShown: false,
          articleId: null,
          i: null,
          style: {
            top: '100px'
          }
        },
        canLeave: false,
        next: null,
        isChanged: false,
        isStakeholder: false,
        tabActive: 'profile',
        changeUrl: false,
        companyId: null,
        datepicker: {
          subscription: null,
          shown: false,
          keepFocus: false
        },
        activeSection: 'companyDetails'
      }
    },
    computed: {
      ...mapGetters([
        'selectedHightCont',
        'getCompaniesForSelect',
        'getUserRole',
        'getUserCompany',
        'getConfData',
        'defaultAssigneeForSelect'
      ]),
      preparedCompanies () {
        let companyList = []
        for (let company in this.getCompaniesForSelect) {
          if (this.getCompaniesForSelect[company].value !== this.companyId * 1 && this.getCompaniesForSelect[company].parent !== 1) {
            companyList.push(this.getCompaniesForSelect[company])
          }
        }
        return companyList
      }
    },
    methods: {
      ...mapActions([
        'getCompanies',
        'clearConfAction',
        'setInformationMsg',
        'initConfAction',
        'authLogout',
        'getTaskAssignee'
      ]),
      openEditEmails: function () {
        this.canEditEmails = true
      },
      openEditDetails: function () {
        this.canEditDetails = true
      },
      openEditOwner: function () {
        this.canEditOwner = true
      },
      openTasksSettings: function () {
        this.canEditTasksSettings = true
      },
      closeEditEmails: function () {
        this.company.approvedEmails = this.initialData.approvedEmails
        this.canEditEmails = false
        this.errors.clean()
      },
      closeEditDetails: function () {
        this.company.details = this.initialData.details
        this.canEditDetails = false
        this.errors.clean()
      },
      closeEditOwner: function () {
        this.company.ownerData = this.initialData.ownerData
        this.canEditOwner = false
        this.errors.clean()
      },
      closeEditTasksSettings: function () {
        this.company.tasksSettings = this.initialData.tasksSettings
        this.canEditTasksSettings = false
        this.errors.clean()
      },
      closeMsg: function () {
        this.errors.clear()
      },
      changeUrlConfirmed () {
        this.changeUrl = true
      },
      fieldChange () {
        this.isChanged = true
      },
      getCompanyData () {
        this.$http.put(api.URLS.companyCreate, {id: this.companyId}, api.headersAuthSettings).then((res) => {
          let companyDetails = this.company
          // set received data
          companyDetails.details.id = res.body.id
          // company details
          companyDetails.details.name = res.body.name
          companyDetails.details.parent = null
          if (res.body.parent !== null) {
            companyDetails.details.parent = {
              id: res.body.parent.id,
              label: res.body.parent.name,
              value: res.body.parent.id
            }
          }
          companyDetails.details.industry = null
          if (res.body.industry !== null) {
            companyDetails.details.industry = {
              id: res.body.industry.id,
              label: res.body.industry.name,
              value: res.body.industry.id
            }
          }
          companyDetails.details.subscriptionEnd = this.convertDate(res.body.subscription_end, '/')
          companyDetails.details.employeeLimit = res.body.employee_limit
          companyDetails.details.enabled = ''
          companyDetails.details.url = res.body.url
          // company email endings
          companyDetails.approvedEmails = res.body.email_endings !== null ? JSON.parse(res.body.email_endings) : companyDetails.approvedEmails
          // company owner data
          companyDetails.ownerData.firstName = res.body.owner_first_name
          companyDetails.ownerData.lastName = res.body.owner_last_name
          companyDetails.ownerData.phoneNumber = res.body.owner_phone_number
          companyDetails.ownerData.email = res.body.owner_email
          companyDetails.tasksSettings.contraption = res.body.contraption
          companyDetails.tasksSettings.defaultAssignee = null
          if (res.body.default_assignee !== null) {
            companyDetails.tasksSettings.defaultAssignee = {
              id: res.body.default_assignee.id,
              label: res.body.default_assignee.first_name + ' ' + res.body.default_assignee.last_name,
              value: res.body.default_assignee.id
            }
          }
          // set initial data
          this.initialData.details.id = companyDetails.details.id
          this.initialData.details.name = companyDetails.details.name
          this.initialData.details.parent = companyDetails.details.parent
          this.initialData.details.industry = companyDetails.details.industry
          this.initialData.details.subscriptionEnd = companyDetails.details.subscriptionEnd
          this.initialData.details.employeeLimit = companyDetails.details.employeeLimit
          this.initialData.details.enabled = companyDetails.details.enabled
          this.initialData.details.url = companyDetails.details.url
          this.initialData.approvedEmails = companyDetails.approvedEmails
          this.initialData.ownerData.firstName = companyDetails.ownerData.firstName
          this.initialData.ownerData.lastName = companyDetails.ownerData.lastName
          this.initialData.ownerData.phoneNumber = companyDetails.ownerData.phoneNumber
          this.initialData.ownerData.email = companyDetails.ownerData.email
          this.datepicker.subscription = companyDetails.ownerData.subscriptionEnd

          document.title = res.body.name + '\'s details | Clear Assured'
          if (window.ga) {
            window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
            window.ga('send', 'pageview', {
              'page': location.pathname,
              'location': location.href,
              'title': document.title
            })
          }
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'error'
            })
            this.$router.push(props.href)
          }
          if (err.status === 401) {
            this.authLogout()
          }
        })
      },
      updateCompanyDetails () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let companyData = {
          id: this.company.details.id,
          companyName: this.company.details.name,
          parent: this.company.details.parent,
          industry: this.company.details.industry,
          url: this.company.details.url
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, companyData, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.name + ' company details was successfully updated.'
              this.infMsgDescription = 'Please note all edits are being logged. '
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
              this.canEditDetails = !this.canEditDetails
            })
            .catch((err) => {
              this.disableAPI = false
              console.log('err', err)
              this.infMsgTitle = 'Error. We were not able to update this company because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
            })
      },
      updateCompanyEmails () {
        if (this.disableAPI) return
        let emailEndings = {
          id: this.company.details.id,
          emailEndings: this.company.approvedEmails
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, emailEndings, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.name + ' company approved emails was successfully updated.'
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.canEditEmails = false
              this.getCompanyData()
            })
            .catch((err) => {
              this.getCompanyData()
              this.disableAPI = false
              this.infMsgTitle = 'Error. We were not able to update this company because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.canEditEmails = false
            })
        this.messageDisplay = true
      },
      updateCompanyOwner () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let owner = {
          id: this.company.details.id,
          ownerFirstName: this.company.ownerData.firstName,
          ownerLastName: this.company.ownerData.lastName,
          ownerPhoneNumber: this.company.ownerData.phoneNumber,
          ownerEmail: this.company.ownerData.email
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, owner, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.name + ' company owner details was successfully updated.'
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
              this.canEditOwner = !this.canEditOwner
            })
            .catch((err) => {
              this.disableAPI = false
              console.log('err', err)
              this.infMsgTitle = 'Error. We were not able to update this company because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
            })
      },
      updateCompanyTasksSettings () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let companyData = {
          id: this.company.details.id,
          contraption: this.company.tasksSettings.contraption,
          defaultAssignee: this.company.tasksSettings.defaultAssignee
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, companyData, api.headersAuthSettings)
          .then((res) => {
            this.disableAPI = false
            this.infMsgTitle = res.body.name + ' company tasks settings was successfully updated.'
            this.infMsgDescription = 'Please note all edits are being logged. '
            this.infMsgClass = 'success'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getCompanyData()
            this.canEditTasksSettings = !this.canEditTasksSettings
          })
          .catch((err) => {
            this.disableAPI = false
            this.infMsgTitle = 'Error. We were not able to update this company because '
            for (let error in err.body.error.exception) {
              this.infMsgTitle += err.body.error.exception[error].message + ' '
            }
            this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
            this.infMsgClass = 'error'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            this.getCompanyData()
          })
      },
      goToCompanyList () {
        let props = this.$router.resolve({
          name: 'companies'
        })
        location.href = props.href
      },
      changeTabActive (tab) {
        this.tabActive = tab
      },
      addEmailRow: function () {
        this.company.approvedEmails.push({
          email: ''
        })
      },
      removeElement: function (index) {
        this.company.approvedEmails.splice(index, 1)
      },
      dateSelected (e) {
        this.company.details.subscriptionEnd = this.convertDate(e, '/')
        this.datepicker.shown = false
      },
      convertDate (payload, delimetr) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
      },
      documentClick (e) {
        let self = this
        if (self.datepicker.shown) {
          let datepicker = document.getElementById('date-selector')
          let target = e.target
          if (!this.isDescendant(datepicker, target)) {
            self.datepicker.shown = false
          }
        }
      },
      isDescendant (parent, child) {
        var node = child.parentNode
        while (node !== null) {
          if (node === parent) {
            return true
          }
          node = node.parentNode
        }
        return false
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          setTimeout(function () {
            element.focus()
          })
        }
      },
      posY (elm) {
        let test = elm
        let top = 0
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop
          test = test.offsetParent
        }
        return top
      },
      scrollY () {
        if (window.pageYOffset) {
          return window.pageYOffset
        }
        return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      },
      isScrolledIntoView (elem) {
        let docViewTop = this.scrollY()
        let docViewBottom = docViewTop + window.outerHeight
        let elemTop = this.posY(elem) + 300
        let elemBottom = elemTop + elem.offsetHeight
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
      },
      handleScroll () {
        let sections = this.$refs
        for (let index in sections) {
          let section = sections[index]
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index
          }
        }
      }
    },
    components: {
      AppSelect
    },
    watch: {
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'delete') this.deleteCompanyConfirmed()
          if (this.confOpened === 'archive') this.archiveCompanyConfirmed()
          if (this.confOpened === 'changeUrl') this.changeUrlConfirmed()
          this.clearConfAction()
        }
      },
      'company.details.url' (value) {
        if (value && value !== this.initialData.details.url && this.changeUrl === false) {
          this.confOpened = 'changeUrl'
          this.initConfAction({
            actionName: 'changeUrl'
          })
        }
      }
    },
    created () {
      this.companyId = this.getUserCompany
      document.onclick = this.documentClick
      window.addEventListener('scroll', this.handleScroll)
    },
    mounted () {
      this.getCompanyData()
      this.getCompanies()
      this.getTaskAssignee()
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style src='@/assets/scss/components/profile.scss' lang='scss' />



// WEBPACK FOOTER //
// CompanySubscription.vue?a23ca7ae